var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step4" }, [
    _c("div", { staticClass: "content" }, [
      _c("img", {
        staticClass: "icon",
        attrs: { alt: "Completed", src: "images/step3-focus.svg" },
      }),
      _vm._v(" "),
      _c("label", { staticClass: "title" }, [_vm._v("CONGRATULATIONS!")]),
      _vm._v(" "),
      _c("label", { staticClass: "subtitle" }, [
        _vm._v("Your appointment has been confirmed."),
      ]),
      _vm._v(" "),
      _c("label", { staticClass: "message" }, [
        _vm._v(
          "To cancel your appointment call the " +
            _vm._s(_vm.clinic.name) +
            " office."
        ),
      ]),
      _vm._v(" "),
      _c("label", { staticClass: "message" }, [
        _vm._v(
          "Please cancel no less than 24 hours prior to your appointment time."
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "footer-actions mt-4" }, [
      _c(
        "button",
        {
          staticClass: "btn-beltone xl",
          on: {
            click: function ($event) {
              return _vm.returnToHomepage()
            },
          },
        },
        [_vm._v("Return To Homepage")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }